import React, { useEffect, useState } from 'react'

export const Overview = () => {
     const [isVisible, setIsVisible] = useState(false);
    
      useEffect(() => {
        setIsVisible(true);
      }, []);
  return (
    <>
    
    <div
        className={` bg-white  transition-all  duration-1000 delay-500 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"
        }`}
      >
        <div className=" py-8 max-w-7xl mx-auto backdrop-blur-sm   grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { label: " Active Forex Traders", value: "50K+" },
            { label: " Supported Currency Pairs", value: "100+" },
            { label: " Monthly Trading Volume", value: "$500M+" },
            { label: "Bot Uptime & Reliability", value: "99.9%" },
          ].map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-gradient-to-r from-[#263283] to-[#ed2924] text-2xl md:text-3xl font-bold">
                {stat.value}
              </div>
              <div className="text-indigo-300 text-sm">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    
    
    </>
  )
}
